import type { ThreadPostState, ThreadState } from "@/entities/thread";

export function markThreadPostAsTrash(
  state: ThreadState,
  postSeq: number,
): ThreadState {
  const target = state.postStates.find(
    (postState) => postState.seq === postSeq,
  );
  if (target?.status === "trash") return state;

  if (!target) {
    const optimisticPostState: ThreadPostState = {
      seq: postSeq,
      status: "trash",
      reactions: { up: 0 },
    };
    return {
      ...state,
      postStates: [...state.postStates, optimisticPostState].sort(
        (left, right) => left.seq - right.seq,
      ),
    };
  }

  return {
    ...state,
    postStates: state.postStates.map((postState) =>
      postState.seq === postSeq ? { ...postState, status: "trash" } : postState,
    ),
  };
}

export function shouldApplyOptimisticPostDeletion(
  state: ThreadState,
  postSeq: number,
): boolean {
  return (
    state.postStates.find((postState) => postState.seq === postSeq)?.status !==
    "trash"
  );
}

export function shouldInvalidateThreadStateAfterDelete(
  activeThreadDeletes: number,
): boolean {
  return activeThreadDeletes <= 1;
}

export function restoreThreadPostState(
  state: ThreadState,
  postSeq: number,
  previousPostState: ThreadPostState | undefined,
): ThreadState {
  if (!previousPostState) {
    return {
      ...state,
      postStates: state.postStates.filter(
        (postState) => postState.seq !== postSeq,
      ),
    };
  }

  const targetExists = state.postStates.some(
    (postState) => postState.seq === postSeq,
  );
  if (!targetExists) {
    return {
      ...state,
      postStates: [...state.postStates, previousPostState].sort(
        (left, right) => left.seq - right.seq,
      ),
    };
  }

  return {
    ...state,
    postStates: state.postStates.map((postState) =>
      postState.seq === postSeq
        ? { ...postState, status: previousPostState.status }
        : postState,
    ),
  };
}
